/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #596F4F, step up 8%, step down 11%
// https://www.tailwindshades.com/#color=101.25000000000001%2C16.842105263157894%2C37.254901960784316&step-up=8&step-down=11&hue-shift=0&name=cactus&base-stop=5&v=1&overrides=e30%3D
const primary = {
  lighter: '#809C74', // 300
  light: '#6C8760', // 400
  main: '#596F4F', // 500
  dark: '#3F4E38', // 600
  darker: '#242D20', // 700
};

// Base color: #A0A39F, step up 8%, step down 14%
// https://www.tailwindshades.com/#color=102.85714285714286%2C3.999999999999985%2C65.68627450980392&step-up=8&step-down=14&hue-shift=0&name=bud&base-stop=5&v=1&overrides=e30%3D
const grey = {
  100: '#F2F3F2',
  200: '#DEDFDD',
  300: '#C9CBC8',
  400: '#B4B7B4',
  500: '#A0A39F',
  600: '#848782',
  700: '#686B66',
  800: '#4C4E4B',
  900: '#30312F',
  500_8: alpha('#A0A39F', 0.08),
  500_12: alpha('#A0A39F', 0.12),
  500_16: alpha('#A0A39F', 0.16),
  500_24: alpha('#A0A39F', 0.24),
  500_32: alpha('#A0A39F', 0.32),
  500_48: alpha('#A0A39F', 0.48),
  500_56: alpha('#A0A39F', 0.56),
  500_80: alpha('#A0A39F', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    grey,
    background: {
      default: '#E2E8DE',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha('#729E66', 0.16), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: '#BBDC95',
      menuActiveText: '#385F27',
      menuDefaultText: primary.main,
      menuHoverBg: alpha('#729E66', 0.12),
      menuHoverText: primary.main,
      menuSecondaryText: grey[600],
      searchHoverBorder: primary.light,
    },
  },
};
